
import Vue from 'vue';

export default Vue.extend({
	name: 'GridMetricsSlot',
	mounted() {
		const slotElement = this.$el.firstChild;
		const childElements = slotElement?.childNodes;
		if (slotElement && childElements && childElements.length === 1) {
			const [child] = childElements;
			const clone = child.cloneNode();
			slotElement.appendChild(clone);
		}
	},
});
